import { useSnapshot } from 'valtio'
import Link from 'next/link'
import { type ReactElement } from 'react'
import { recurringPaymentProxy } from '../../../../../../shared/proxies/recurringPaymentProxy'
import { buildAppCustomerPath } from '../../../../../../pages/app/customers/[id]'

export function CustomerContainer (): ReactElement {
  const snap = useSnapshot(recurringPaymentProxy)

  const companyName = snap.recurringPayment?.customer?.companyName
  const customerPath = buildAppCustomerPath(snap.recurringPayment?.customer?.id ?? '')

  return (
    <div className="bg-white shadow rounded py-4 mb-8 px-6">
      <div className="text-xl mb-4">
        Customer
      </div>

      <Link href={customerPath} className="font-semibold text-wpy-blue-600 whitespace-nowrap">
        <span className="mr-2">
          {snap.recurringPayment?.customer?.firstName}
        </span>

        <span>
          {snap.recurringPayment?.customer?.lastName}
        </span>
        <span className="ml-4">
          {companyName ? `(${companyName})` : ''}
        </span>
      </Link>

      <div className=" font-light">
        {`${snap.recurringPayment?.customer?.addressOne ?? ''} 
         ${snap.recurringPayment?.customer?.addressTwo ?? ''}
         ${snap.recurringPayment?.customer?.city ?? ''}, 
         ${snap.recurringPayment?.customer?.state ?? ''} 
         ${snap.recurringPayment?.customer?.postalCode ?? ''}`}
      </div>

      <div className=" font-light">
        {snap.recurringPayment?.customer?.email}
      </div>

    </div>
  )
}
